export default __webpack_public_path__ + "static/media/exit-icon.0c2f7ecc.png";